export default {
  title: 'Top-up & Data reports',
  tableHeaderActionTooltip: 'Create new Top-up & Data report',
  dialog: {
    title: {
      generateReport: 'Generate Top-up & Data report',
      deleteReport: 'Delete Top-up & Data report',
      cancelReport: 'Cancel Top-up & Data report',
      regenerateReport: 'Regenerate Top-up & Data report',
      retryReport: 'Retry Top-up & Data report generation'
    }
  },
  tooltip: {
    generateReport: 'Generate Top-up & Data report',
    cancel: 'Cancel',
    delete: 'Delete',
    details: 'Details',
    download: 'Download',
    regenerate: 'Regenerate',
    retry: 'Retry'
  },
  reportName: {
    label: 'Name',
    placeholder: 'Enter Top-up & Data report name'
  },
  table: {
    emptyMsg: "You don't have any Top-up & Data reports to display"
  },
  warningMsg:
    // eslint-disable-next-line max-len
    'You reached the max number of active/pending reports. To add a new one, or retry existing you need to delete the existing/pending ones.'
};
